import React from 'react';
import '../../styles/APSIS.css';

export default function APSISExhibitors() {
  return (
    <div className="apsis-page">
      <div className="apsis-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">EXHIBITORS</span>
            <h1>APSIS EXHIBITORS</h1>
            <p>Meet the leading companies and innovators showcasing at APSIS 2026</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        <section className="apsis-exhibitors-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>OUR EXHIBITORS</h2>
           </div>

           <div className="exhibitors-grid">
              <div className="exhibitor-card">
                 <div className="exhibitor-logo">
                    <div className="logo-placeholder">LOGO</div>
                 </div>
                 <h3>Company Name 1</h3>
                 <p>Leading provider of security solutions</p>
                 <div className="exhibitor-category">Cybersecurity</div>
              </div>

              <div className="exhibitor-card">
                 <div className="exhibitor-logo">
                    <div className="logo-placeholder">LOGO</div>
                 </div>
                 <h3>Company Name 2</h3>
                 <p>Innovation in surveillance technology</p>
                 <div className="exhibitor-category">Surveillance</div>
              </div>

              <div className="exhibitor-card">
                 <div className="exhibitor-logo">
                    <div className="logo-placeholder">LOGO</div>
                 </div>
                 <h3>Company Name 3</h3>
                 <p>Advanced access control systems</p>
                 <div className="exhibitor-category">Access Control</div>
              </div>
           </div>
        </section>
      </div>
    </div>
  );
}